import { faCircleQuestion } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { DarkTooltip } from '@framework/ui/atoms/Tooltip';
import { classNames } from '@framework/utils';
type Props = {
  className?: string;
};

export const HelpPageIcon: React.FC<Props> = ({ className }: Props) => {
  const { t } = useTranslation();
  const onClick = () => {
    window.open('https://balus-help.levii.co.jp');
  };

  return (
    <div className={classNames(className, 'relative')}>
      <DarkTooltip tooltip={t('viewModel.helpPage.show')} placement={'bottom'}>
        <button
          className={classNames(
            'relative flex h-12 w-12 items-center justify-center',
            'bg-white text-2xl text-gray-700 hover:bg-gray-200',
            'cursor-pointer rounded-lg shadow-md focus:outline-none'
          )}
          onClick={onClick}
          aria-label={t('viewModel.helpPage.label')}
        >
          <FontAwesomeIcon icon={faCircleQuestion} />
        </button>
      </DarkTooltip>
    </div>
  );
};
